import useCrud from './useCrud'

const useTaskCitizen = (procedureCode, token, taskId) => {
  const { findById } = useCrud(`/v1/procedures/${procedureCode}/tasks`)
  return findById(['task', taskId], { token })
}
export default useTaskCitizen
